require('./brokerRightsCashExchangeStep2.scss');
const WebappRender = require('components/conditionalRender/webappRender')

// @Vendors
const React = require('react');
const PropTypes = require('prop-types');

// @Commons
const { FormattedText, formatText } = require('core/i18n').i18n;

// @Components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKTooltip = require('commonsComponents/OKTooltip');
const BrokerFormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @Constants
const { BROKER_RIGHTS_CASH_EXCHANGE_ID } = require('constants/operationTypes');
const { CHARGE_ACCOUNT_PREFIX, SECOND_STEP, BROKER_PRODUCT_TYPE_CAPITAL_INCREASE } = require('constants/index');

const BrokerRightsCashExchangeStep2 = props => {
    const { immBrokerRightsCashExchange, onChangeManifest, immSelectedContract, setDocumentsRead } = props;
    const showWarning = immBrokerRightsCashExchange.getIn(['steps', SECOND_STEP , 'showWarning'])
    const productNumber = immSelectedContract.getIn(['contract', 'product']);
    const contractNumber = immSelectedContract.getIn(['contract', 'number']);
    const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
    const signaturePatternParams = { chargeAccount }
    const operation = immBrokerRightsCashExchange.get('selectedOperation')
    const isin = operation.get('isin')
    const iso = operation.get('iso')
    const productDefinition = operation.get('descriptionValue')
    const bookletLabel = <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_informativeMessageBookletLabel"/>
    const CNMVLabel = <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_informativeMessageCNMVLabel"/>
    const checkBoxLabel = (
        <BrokerFormattedTextWithComponents
            value="brokerRightsCashExchange-brokerRightsCashExchange_informativeMessageCheckbox"
            injectedComponents={[bookletLabel, CNMVLabel]}
        />
    );

    let documentsNotRead = null;
    if (showWarning) {
        documentsNotRead = (
            <div className="broker-rights-cash-exchange-step2__warning-message">
                <OKMessage type="warning">
                    <FormattedText value="brokerLegalDocumentation-documentsRead" />
                </OKMessage>
            </div>
        )
    }

    let signaturePattern = null;
    if (immBrokerRightsCashExchange.getIn(['steps', SECOND_STEP , 'acceptedManifest'])) {
        signaturePattern = (
            <div className="broker-rights-cash-exchange-step2__group-div">
                <SignaturePattern
                    operationType={BROKER_RIGHTS_CASH_EXCHANGE_ID}
                    operationParams={signaturePatternParams}
                />
            </div>
        )
    }

    return (
        <div className="broker-rights-cash-exchange-step2">
            <div className="broker-rights-cash-exchange-step2__header">
                <h3 className="broker-rights-cash-exchange-step2__title">
                    <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_step2HeaderTitle" />
                </h3>
                <div className="broker-rights-cash-exchange-step2__field">
                    <h4>
                        <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_step2VerifyInformation" />
                    </h4>
                </div>
            </div>
            <WebappRender>
                <div className="broker-request-financial-operation-change-step2__manifest">
                    <BrokerLegalDocumentation
                        isin={isin}
                        iso={iso}
                        productDefinition={productDefinition}
                        productType={BROKER_PRODUCT_TYPE_CAPITAL_INCREASE}
                        reportCompleted={() => setDocumentsRead()}
                    />
                    <div className="broker-rights-cash-exchange-step2__field">
                        <OKMessage type="informative">
                            <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_informativeMessageStep2" />
                        </OKMessage>
                    </div>
                    {documentsNotRead}
                    <OKTooltip
                        content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                        offset={[-50, -5]}
                        placement={'topLeft'}
                        target={
                            <div className="broker-rights-cash-exchange-step2__field">
                                <OKCheckbox
                                    idName="manifestCheckbox"
                                    onChange={onChangeManifest}
                                    value={immBrokerRightsCashExchange.getIn(['steps', SECOND_STEP , 'acceptedManifest'])}
                                    label={checkBoxLabel}
                                    errorState={immBrokerRightsCashExchange.getIn(['steps', SECOND_STEP, 'manifestInvalid'])}
                                    errorMessage={formatText('brokerSubscription-manifestError')}
                                />
                            </div>
                        } />
                </div>
                {signaturePattern}
            </WebappRender>
            <ContactCenterRender>
                <div className="broker-request-financial-operation-change-step2__manifest">
                    <BlockInfo extraClass="broker-rights-cash-exchange-step2__info-container">
                        <div>
                            <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_informativeMessageStep2" />
                        </div>
                    </BlockInfo>
                    <div className="broker-rights-cash-exchange-sidebar__sidecolumn-extra-info">
                        <PrinterPreviewManager />
                    </div>
                    <div className="broker-rights-cash-exchange-step2__group-div">
                        <SignaturePattern
                            operationType={BROKER_RIGHTS_CASH_EXCHANGE_ID}
                            operationParams={signaturePatternParams}
                        />
                    </div>
                </div>
            </ContactCenterRender>
        </div>
    );
}

BrokerRightsCashExchangeStep2.propTypes = {
    immSelectedContract: PropTypes.object.isRequired,
    immBrokerRightsCashExchange: PropTypes.object.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
}

module.exports = BrokerRightsCashExchangeStep2;
